<template>
  <b-overlay :show="loading">
    <div v-if="aprovalTemplate && aprovalTemplate.aprobacion">
      <FlowDetail :readOnly="true"/>
      <Observers :readOnly="true" />
      <b-card title="Consecuencias" v-if="aprovalTemplate && aprovalTemplate.gatillaciones">
        <Consequences :original="aprovalTemplate.gatillaciones" :readOnly="true" />
      </b-card>
      <Steps
        v-if="aprovalTemplate.aprobacion && aprovalTemplate.aprobacion.tipoEjecucion"
        :flowType="aprovalTemplate.aprobacion.tipoEjecucion"
        :readOnly="true"
      />
    </div>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import FlowDetail from '@/febos/chile/approvals/components/templates/FlowDetail';
import Observers from '@/febos/chile/approvals/components/templates/Observers';
import Consequences from '@/febos/chile/approvals/components/templates/Consequences';
import Steps from '@/febos/chile/approvals/components/templates/Steps';

export default {
  name: 'SeeTemplate',
  props: ['approvalId'],
  components: {
    FlowDetail,
    Observers,
    Consequences,
    Steps
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'aprovalTemplate'
    ]),
  },
  methods: {
    ...mapActions('Approvals', [
      'fetchApprovalTemplate'
    ]),
    backToList() {
      this.$router.push({ name: 'approval-templates' });
    }
  },
  async created() {
    this.loading = true;
    await this.fetchApprovalTemplate({
      id: this.approvalId,
      estado: true
    });
    this.loading = false;
  }
};
</script>

<style scoped>
.load-div {
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
